import { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_CLIP } from "MVVM/GraphQL/clip";
import { IClip } from "MVVM/@types";
import { useSetRecoilState, useRecoilValue } from "recoil";

import {
  PlatformState,
  ViewLocationState,
  UniqueIdentifierState,
  ViewSubLocationState,
  KnownState,
} from "MVVM/State/iframe";
import { getQueryParam } from "MVVM/Utilities/QueryParam";
import { IsUserLoggedIn } from "MVVM/State";

import { ActivePlaylistClipState } from "MVVM/State/embeddablePlaylist";

export const EmbeddablePlayerViewModel = () => {
  const activePlaylistClip = useRecoilValue(ActivePlaylistClipState);
  const clipId = new URLSearchParams(window.location.search).get("clip");
  const platformParam = new URLSearchParams(window.location.search).get(
    "platform",
  );
  const knownParam = new URLSearchParams(window.location.search).get("known");

  const setUniqueIdentifier = useSetRecoilState(UniqueIdentifierState);
  const setViewLocation = useSetRecoilState(ViewLocationState);
  const setViewSubLocation = useSetRecoilState(ViewSubLocationState);
  const setPlatform = useSetRecoilState(PlatformState);
  const setKnown = useSetRecoilState(KnownState);
  const isLoggedIn = useRecoilValue(IsUserLoggedIn);

  useEffect(() => {
    const uid = getQueryParam("UID") ?? getQueryParam("uid") ?? "";
    const location = getQueryParam("location") ?? "";
    const subLocation = getQueryParam("sublocation") ?? "";

    setUniqueIdentifier(uid);
    setViewLocation(location);
    setViewSubLocation(subLocation);
  }, [setUniqueIdentifier, setViewLocation, setViewSubLocation]);

  useEffect(() => {
    setPlatform(platformParam);
  }, [platformParam, setPlatform]);

  useEffect(() => {
    if (isLoggedIn) {
      setKnown(true);
    } else {
      setKnown(knownParam === "true" ? true : false);
    }
  }, [knownParam, setKnown, isLoggedIn]);

  const skipQuery = !!activePlaylistClip;

  const {
    data: initialData,
    loading,
    error,
    refetch,
  } = useQuery<{ clip: IClip }>(GET_CLIP, {
    variables: {
      id: clipId || "",
    },
    fetchPolicy: "network-only",
    skip: skipQuery,
  });

  const refetchClip = () => {
    refetch();
  };

  return {
    data: skipQuery ? { clip: activePlaylistClip } : initialData,
    loading,
    error,
    refetchClip,
  };
};
